import { createTheme } from '@mui/material/styles';

const variables = {
    color_brand_primary_01: '#c21b17',
    color_brand_primary_02: '#e9573d',
};

const theme = createTheme({
    palette: {
        primary: {
            main: variables.color_brand_primary_01,
        },
        secondary: {
            main: variables.color_brand_primary_02,
        },
    },
    spacing: 4,
    typography: {
        fontWeightLight: 400,
        fontWeightRegular: 500,
        fontWeightMedium: 600,
        fontWeightBold: 700,
    },
});

export default theme;
